import common from '../../../api/common'

const state = {

}

const actions = {
  listCurUnit({commit}, unitId) {
    return new Promise((resolve, reject) => {
      common.listCurUnit(unitId).then((res) => {
        commit('listUnit', res.result)
        resolve(res.result)
      }).catch(error => {
        reject(error)
      })
    });
  },


  listCurDept({commit}, deptId) {
    return new Promise((resolve, reject) => {
      common.listCurDepartment(deptId).then((res) => {
        commit('listDept', res.result[0].departments)
        resolve(res.result[0].departments)
      }).catch(error => {
        reject(error)
      })
    });
  },

}

const mutations = {

}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/common/vuex/modules/org/unit.js